import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { columnas } from "./columns";
import { toItems, onChange } from "./logic";
import { MotivoGuiaItem } from "./model";

type Item = MotivoGuiaItem;
type ValueItem = models.MotivoCancelacionGuiaModel;
export interface Props {
    value: ValueItem[];
    guias: models.GuiaDTO[];
    onChange: (value: ValueItem[]) => PromiseLike<void> | void;
}

/**
* Listado de guias
*/
class MotivosGuiasListMemNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    guias = (props: Props) => props.guias;
    valores = (props: Props) => props.value;
    items = createSelectorRx(this.guias, this.valores, toItems);

    onMotivoChange = (x: Item, motivo: string) => {
        const oldValue = this.valores(this.props);
        const newValue = onChange(x.IdRegistro, motivo, oldValue);
        
        this.props.onChange(newValue);
    }

    render() {
        const cols = columnas(this);
        const items = this.items(this.props);
        return (
            <div>
                <kea.Title titulo="Motivos de cancelación por guia" />
                <kea.Grid2 items={items} columnas={cols} />
            </div>
        );
    }
}
export const MotivosGuiasListMem = kea.mapProps(componentToRx(MotivosGuiasListMemNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/cancelacion/list/motivoguias/listmem.tsx